/* eslint-disable prettier/prettier */
import PropTypes from "prop-types";
import React, { useState } from "react";

import CategorySelectListPage from "../../../../../containers/administrative/Categories/SelectListPage";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericModal from "../../../../modal-closebtn/index";

const ModelerModalCategoryList = ({
  FormComponents,
  saveCategory,
  element,
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSave = (value) => {
    const obj = [
      {
        [value.id]: true,
        name: value.name,
      },
    ];

    saveCategory(element, obj);
  };

  const onchangeCategorySelect = (value) => {
    handleSave(value);
  };

  return (
    <Provider>
      <GenericModal
        title={language.modelerListCategoriesMenu}
        handleClose={handleClose}
        size="xl"
        bigHeight
        open={open}
      >
        <CategorySelectListPage
          onchangeCategorySelect={onchangeCategorySelect}
          selectedcategories={FormComponents}
        />
      </GenericModal>
    </Provider>
  );
};

ModelerModalCategoryList.propTypes = {
  FormComponents: PropTypes.any,
  theme: PropTypes.object,
  saveCategory: PropTypes.func,
  element: PropTypes.object,
};

export default ModelerModalCategoryList;
